import React from "react";
import { Box } from "@mui/material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        minHeight: 100,
        py: { xs: 3, md: 0 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center",
        textAlign: { xs: "center", md: "left" },
        gap: { xs: 2, md: 8 },
        fontSize: 10,
        color: "white",
        textTransform: "uppercase",
        backgroundColor: "rgb(34, 40, 44)",

        "& ul": {
          display: "flex",
          gap: 4,
          listStyle: "none",
          padding: 0,
          margin: 0,
        },

        "& a": {
          color: "inherit",
          textDecoration: "none",

          "&:hover": {
            textDecoration: "underline",
          },
        },
      }}
    >
      <Box
        component="img"
        src="/assets/v2/AE-Connect.png"
        alt="AE Connect"
        sx={{ width: { xs: 132, md: 196 }, height: "auto" }}
      />

      <ul>
        <li>
          <a href="/v2">System Status</a>
        </li>
        <li>
          <a href="/privacy-policy" target="_blank">
            Privacy Policy
          </a>
        </li>
      </ul>

      <Box component="p" sx={{ fontSize: 8, m: 0 }}>
        &copy; {new Date().getFullYear()} North American Division of Seventh-day
        Adventists.
        <br />
        All rights reserved.
      </Box>
    </Box>
  );
}
